import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import Qrcode from './qrcode.vue';

export default {
  name: 'getPreviewUrl.vue',

  components: {
    Qrcode: Qrcode
  },

  data: function data() {
    return {
      loading: false
    };
  },


  computed: _extends({}, mapState({
    qrcodeUrl: function qrcodeUrl(state) {
      return state.creative.template.qrcodeUrl;
    }
  }), {
    popoverAttrs: function popoverAttrs() {
      return {
        placement: 'bottom',
        trigger: 'click'
      };
    },
    buttonAttrs: function buttonAttrs() {
      return {};
    }
  }),

  methods: {
    handleShow: function handleShow() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return _this.$store.dispatch('creative/template/saveTemplate');

              case 3:
                _context.next = 5;
                return _this.$store.dispatch('creative/template/getQrcodePreviewUrl');

              case 5:
                _this.loading = false;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};